import apiFetch from '../apiFetch'

export default function (idAgenda) {
  return apiFetch({endPoint: `Agenda/getAgenda?idAgenda=${idAgenda}`, method: 'GET', body: null})
}
